module.exports = __webpack_public_path__ + "static/media/copy-active-icon.097b82af.svg";